import axios from "../../http/axios";
import * as actionTypes from "./actionTypes";

export const GET_VAT_SUCCESS = "GET_VAT_SUCCESS";
export const GET_VAT_FAIL = "GET_VAT_FAIL";

export const EDIT_VAT_SUCCESS = "EDIT_VAT_SUCCESS";
export const EDIT_VAT_FAIL = "EDIT_VAT_FAIL";


export const getVAT = () => {
    return (dispatch, getState) => {

        let url = `/configs/?name=vat`;

        let token = getState().auth.token;
        const doesRemember = getState().auth.doesRemember;
        if (doesRemember) {
            token = localStorage.getItem("token");
        }
        axios
            .get(url, {
                headers: { Authorization: "JWT " + token }
            })
            .then(response => {
                dispatch({
                    type: GET_VAT_SUCCESS,
                    payload: response.data
                });
            })
            .catch(error => {
                if (error.response && error.response.status === 403) {
                    dispatch({ type: actionTypes.AUTH_SIGNOUT });
                } else {
                    dispatch({
                        type: GET_VAT_FAIL
                    });
                }
            });
    };
};

export const editVAT = (id, data) => {
    return (dispatch, getState) => {

        let url = `/configs/${id}/`;

        let token = getState().auth.token;
        const doesRemember = getState().auth.doesRemember;
        if (doesRemember) {
            token = localStorage.getItem("token");
        }
        axios
            .patch(url, data, {
                headers: { Authorization: "JWT " + token }
            })
            .then(response => {
                dispatch({
                    type: EDIT_VAT_SUCCESS
                });
            })
            .catch(error => {
                if (error.response && error.response.status === 403) {
                    dispatch({ type: actionTypes.AUTH_SIGNOUT });
                } else {
                    dispatch({
                        type: EDIT_VAT_FAIL
                    });
                }
            });
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/settings.js